import React, { useEffect } from 'react';
import { View } from '@/styles/reactnative';

const DerivativesNavBarTabs = React.memo(
  ({ tab, setTab, t, textsilver }: any) => {
    // console.log('렌더링됨')
    const tabs = ['L', 'M', 'CL'];

    return (
      <View
        style={{
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          paddingLeft: 10,
          paddingTop: 16,
          width: '100%',
        }}
      >
        <View
          style={{
            flexDirection: 'row',
            justifyContent: 'flex-start',
            gap: 16,
            width: '100%',
            flexWrap: 'wrap',
            background: 'transparent',
            borderRadius: 10,
          }}
        >
          {tabs?.map((item, index) => {
            let temp = tab;

            if (temp == 'CM') {
              temp = 'CL';
            } else {
              if (temp == 'CL') {
                temp = 'CL';
              }
            }

            return (
              <button
                key={`DerivativesNavBarTabs_${index}`}
                style={{
                  color: item == temp ? '#007AFF' : textsilver,
                  borderBottom: item == temp ? '2px solid #007AFF' : '0',
                  borderTop: 0,
                  borderLeft: 0,
                  borderRight: 0,
                  padding: '10px 0',
                  fontWeight: 600,
                  fontSize: 14,
                  lineHeight: '16.71px',
                }}
                onClick={() => setTab(item)}
              >
                {t(
                  item == 'L'
                    ? 'limit'
                    : item == 'M'
                      ? 'market'
                      : item == 'T' || item == 'CM' || item == 'CL'
                        ? 'trigger'
                        : ''
                )}
              </button>
            );
          })}
        </View>
      </View>
    );
  },
  (prevProps, nextProps) => {
    return (
      prevProps.tab === nextProps.tab &&
      prevProps.textsilver === nextProps.textsilver &&
      prevProps.t === nextProps.t
    );
  }
);

export default DerivativesNavBarTabs;
